// extracted by mini-css-extract-plugin
module.exports = {"Layout":"layout-module--Layout--1tEK4","Footer":"layout-module--Footer--2DGJB","defaultTextColor":"layout-module--default-text-color--1M2HA"};